import { render, staticRenderFns } from "./AddressLogDialog.vue?vue&type=template&id=33f0d425&"
import script from "./AddressLogDialog.vue?vue&type=script&lang=js&"
export * from "./AddressLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports